export default __webpack_public_path__ + "static/media/tag_grey.ded4a0dd.svg";